import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { FilterProvider } from './context/filterContext';
import { store, persistor } from "./redux/store";   // <-- make sure path is correct

console.log = () => {};
console.info = () => {};
console.warn = () => {};
console.error = () => {};
console.debug = () => {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <FilterProvider>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </FilterProvider>
  </Provider>
);

reportWebVitals();
